module.exports = __webpack_public_path__ + "img/30.64a6bd1d.jpg";